import { FETCH_GUIDE } from './constants'

export const fetchGuide = {
  request: (deviceId, guideId) => ({
    type: FETCH_GUIDE.REQUEST,
    deviceId,
    guideId
  }),
  success: (guide) => ({ type: FETCH_GUIDE.SUCCESS, guide }),
  failure: (error) => ({ type: FETCH_GUIDE.FAILURE, error })
}
